<fap-header>
    <div class="d-flex filters align-items-center">
        <div class="tree_combo mr-3">
            <fap-tree-combo></fap-tree-combo>
          </div>
        <div class="add_btn mr-3">
          <fap-round-button [backgroundColor]="'tertiary'" [routerLink]="'/pages/farm/create'"></fap-round-button>
        </div>
        <fap-search-filter [isSearchEnabled]="true"></fap-search-filter>
      </div>
</fap-header>
<ng-container *ngFor="let lot of lots">
    <!-- <div class="card-header-wrapper d-flex theme_bg custom_header">
        <div class="rw d-flex" style="justify-content: space-between; width:100%">
            <div class="d-flex wrp">
            <h2 class="card-header-title custom_title" (click)="clickedLotTitle.emit(lot)">{{ lot.name }}</h2>
            <div [routerLink]=""
                 [ngStyle]="{'cursor': 'pointer'}"
                 class="d-flex align-items-center px-2">
                <img src="assets/images/fap/pencil.svg" class="fa-pencil ml-1"/>
            </div>
            
            </div>
            <div class="btns d-flex" style="padding-right: 30px;">
                <i [routerLink]="'/pages/lot/edit/' + lot.id" class="fa fa-pencil mr-2 ter-btn-icon ter-btn-icon-success"></i>
                <div [routerLink]="'/pages/fields/create'" [queryParams]="{lot: lot.id}"
                 class="align-items-center">
                <fap-round-button [backgroundColor]="'tertiary'"></fap-round-button>
            </div>
                <i class="material-icons ter-btn-icon ter-btn-icon-danger" (click)="deleteLot.emit(lot.id)">delete_outline</i>
            </div>
        </div>
    </div> -->
    
    <fap-section-container
        [title]="lot.name"
        [isEditable]="true"
        [isAddEnabled]="true"
        (click)="clickedLotTitle.emit(lot)"
        (clicked)="newField()"
        (editClicked)="editLot(lot.id)"
    >
        <div class="lots-grid" *ngIf="hasFields(lot.id)">
            <fap-field-card [field]="field" [parties]="parties"
                *ngFor="let field of lotToFieldsMap[lot.id]"
                (click)="clickedFieldCard.emit(field)" (deleteField)="deleteField.emit($event)">
            </fap-field-card>
        </div>
    </fap-section-container>
</ng-container>
